export function copyLink() {
    $(".copylink").on("click", function (event) {
        event.preventDefault();
        let $this = $(this);
        let $parent = $(this).parent();
        let copyText = $this.attr("href");
        navigator.clipboard.writeText(copyText);
        $parent.append("<span class='copylink-note' style='display: none'>URL copied to clipboard</span>");
        $parent.find(".copylink-note").show(300);
        setTimeout(function () {
            $parent.find(".copylink-note").hide(300);
        }, 2000);
        setTimeout(function () {
            $parent.find(".copylink-note").remove();
        }, 2200);
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/copyLink.js